
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import type { TimeRangeOption } from '@/types/analytics';

interface TimeRangeSelectorProps {
  value: TimeRangeOption;
  onChange: (value: TimeRangeOption) => void;
}

export function TimeRangeSelector({ value, onChange }: TimeRangeSelectorProps) {
  return (
    <Select
      value={value}
      onValueChange={(value) => onChange(value as TimeRangeOption)}
    >
      <SelectTrigger className="w-[180px] bg-white dark:bg-gray-800 border-2 text-foreground font-medium">
        <SelectValue placeholder="Select time range" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="24h">Last 24 Hours</SelectItem>
        <SelectItem value="7days">Last 7 Days</SelectItem>
        <SelectItem value="30days">Last 30 Days</SelectItem>
        <SelectItem value="90days">Last 90 Days</SelectItem>
      </SelectContent>
    </Select>
  );
}
